

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// import { getFirestore } from "firebase/firestore";
import {
  initializeFirestore,
  persistentLocalCache
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDOsb6Y95s1kazdHRA_ERgQeZbmx9OP4Qk",
  authDomain: "ecotrack-44036.firebaseapp.com",
  projectId: "ecotrack-44036",
  storageBucket: "ecotrack-44036.appspot.com",  
  messagingSenderId: "969994494359",
  appId: "1:969994494359:web:2363a0ebf4c3e38d5a24d2",
  measurementId: "G-3MQH3VPC43"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: undefined
  }),
  experimentalForceLongPolling: true 
});
